import { render, staticRenderFns } from "./WorkflowJobLock.vue?vue&type=template&id=80fe8138&"
import script from "./WorkflowJobLock.vue?vue&type=script&lang=ts&"
export * from "./WorkflowJobLock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports